export default "__VITE_ASSET__Y$_wlN24__"